package at.theatervogelweide.admin.contract.sponsors

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/** Sponsoren (#94): one list in the order the public site shows it, for every admin. */
@Rpc
interface SponsorService {
    suspend fun list(): AdminResult<List<SponsorEntry>>

    /** The new sponsor goes to the end of the list. */
    suspend fun create(draft: SponsorDraft): AdminResult<SponsorEntry>

    suspend fun save(sponsor: VersionedId, draft: SponsorDraft): AdminResult<SponsorEntry>

    /** [order] must list every sponsor, each with the version the web app last saw; answers with the new list. */
    suspend fun reorder(order: List<VersionedId>): AdminResult<List<SponsorEntry>>

    /** Deletes the sponsor and, once nothing refers to it, its logo. */
    suspend fun delete(sponsor: VersionedId): AdminResult<Unit>
}
